import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IProduktinstruktionSearchResult } from "./IProduktinstruktionSearchResult";
import { IProduktdefinitionBasdata, IRegion } from "./ProduktdefinitionModels";

export class ProduktinstruktionViewModel {
    selected = false;

    get tradslag() {
        return this.model.tradslag;
    }
    get namn() {
        return this.model.namn;
    }
    get puid() {
        return this.model.puid;
    }
    get version() {
        return this.model.version;
    }
    get sortiment() {
        return this.model.sortiment;
    }
    get mottagningsplats() {
        return this.model.mottagningsplats;
    }

    get aktiv() {
        return this.model.aktiv;
    }

    get id() {
        return this.model.id;
    }

    get handelssortiment() {
        return this.model.handelssortiment;
    }

    get produkt() {
        return this.model.produkt;
    }

    get skapad() {
        return DateUtils.formatDateString(this.model.skapad, DateUtils.datetimeformatWithoutMillis);
    }

    get senastAndrad() {
        return DateUtils.formatDateString(this.model.senastAndrad, DateUtils.datetimeformatWithoutMillis);
    }

    get kapfonsterNedreGrans() {
        return this.model.kapfonsterNedreGrans;
    }

    get kapfonsterOvreGrans() {
        return this.model.kapfonsterOvreGrans;
    }

    get kapfonster() {
        const nedre = !ObjectUtils.isNullOrUndefined(this.model.kapfonsterNedreGrans) ? this.model.kapfonsterNedreGrans : "-";
        const ovre = !ObjectUtils.isNullOrUndefined(this.model.kapfonsterOvreGrans) ? this.model.kapfonsterOvreGrans : "-";
        return `${nedre} till ${ovre}`;
    }

    get minMaxTopDiameter() {
        return `${this.model.minstaToppdiameter} - ${this.model.maxdiameter}`;
    }

    get kvalitetToleransTopp() {
        return this.model.kvalitetToleransTopp;
    }

    get harAktiv() {
        return this.model.harAktiv;
    }

    get harUtkast() {
        return this.model.harUtkast;
    }

    get regioner() {

        return this.getRegionNamnSorted().join(", ");
    }

    get cssClass() {
        return this.model.harUtkast ? "rask-row-todo" : null;
    }

    constructor(private readonly model: IProduktinstruktionSearchResult, private readonly basData: IProduktdefinitionBasdata) {
    }

    private getRegionNamnSorted() {
        const regioner = this.model?.regioner;
        if (!regioner?.length) {
            return [];
        }
        if (!this.basData?.regioner?.length) {
            // eslint-disable-next-line sonarjs/no-misleading-array-reverse
            return regioner.sort((a: IRegion, b: IRegion) => a.sekvensnummer - b.sekvensnummer).map(x => x.namn);
        }

        const nordligaRegioner = this.getRegionerNamnByMarknadsomrade("Nord");
        const sydligaRegioner = this.getRegionerNamnByMarknadsomrade("Syd");
        return [
            ...nordligaRegioner,
            ...sydligaRegioner
        ];

    }

    private getRegionerNamnByMarknadsomrade(marknadsomradeNamn: string) {
        if (this.produktHasAllRegionsInMarknadsomrade(marknadsomradeNamn)) {
            return [marknadsomradeNamn];
        } else {
            return this.model.regioner.filter(x => x.marknadsomradeNamn === marknadsomradeNamn && x.aktiv).map(x => x.namn);
        }
    }

    private produktHasAllRegionsInMarknadsomrade(marknadsOmradeNamn: string) {
        const basDataRegioner = this.getAktivaBasdataRegioner(marknadsOmradeNamn);
        const produktInstruktionRegioner = this.getAktivaProduktinstruktionsRegioner(marknadsOmradeNamn);
        return basDataRegioner.every((x: string) => produktInstruktionRegioner.includes(x));
    }

    private getAktivaBasdataRegioner(marknadsomradeNamn: string) {
        return this.basData.regioner.filter(x => (x.marknadsomradeNamn.toLocaleLowerCase() === marknadsomradeNamn.toLocaleLowerCase()) && x.aktiv).map(x => x.namn);
    }

    private getAktivaProduktinstruktionsRegioner(marknadsomradeNamn: string) {
        return this.model.regioner.filter(x => (x.marknadsomradeNamn.toLocaleLowerCase() === marknadsomradeNamn.toLocaleLowerCase()) && x.aktiv).map(x => x.namn);
    }
}
